import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./studentMess.css";

export default function StudentMessList() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [list, setList] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [search, setSearch] = useState("");
  const [room, setRoom] = useState("");
  const [food, setFood] = useState("");

  const [loading, setLoading] = useState(false);

  // ================= LOAD DATA =================
  const loadData = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/hostel/mess/students/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });

      const students = res.data.students || [];
      setList(students);
      setFiltered(students);
    } catch (err) {
      console.error(err);
      alert("Failed to load mess students");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // ================= FILTER LOGIC =================
  useEffect(() => {
    let data = [...list];

    if (search) {
      data = data.filter((s) =>
        s.student_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (room) {
      data = data.filter(
        (s) => String(s.room_number) === String(room)
      );
    }

    if (food) {
      data = data.filter((s) => s.food_type === food);
    }

    setFiltered(data);
  }, [search, room, food, list]);

  // ================= ACTIONS =================

  // ✅ MARK PAID / UNPAID
  const togglePayment = async (messId, isPaid) => {
    try {
      await API.post(
        "/school-admin/hostel/mess/payment/",
        {
          mess_id: messId,
          is_paid: !isPaid,
        },
        {
          headers: { "X-SCHOOL-ID": school.school.id },
        }
      );

      loadData();
    } catch (err) {
      console.error(err);
      alert("Failed to update payment status");
    }
  };

  // ❌ REMOVE FROM MESS
  const removeFromMess = async (messId) => {
    if (!window.confirm("Remove this student from mess?")) return;

    try {
      await API.delete(
        `/school-admin/hostel/mess/${messId}/`,
        {
          headers: { "X-SCHOOL-ID": school.school.id },
        }
      );

      loadData();
    } catch (err) {
      console.error(err);
      alert("Failed to remove student");
    }
  };

  // unique rooms
  const rooms = [...new Set(list.map((s) => s.room_number))];

  // ================= UI =================
  return (
    <div className="mess-page">
      <h2>🍽 Student Mess Management</h2>

      {/* 🔎 FILTER BAR */}
      <div className="filter-bar">
        <input
          type="text"
          placeholder="Search student..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select value={room} onChange={(e) => setRoom(e.target.value)}>
          <option value="">All Rooms</option>
          {rooms.map((r) => (
            <option key={r} value={r}>Room {r}</option>
          ))}
        </select>

        <select value={food} onChange={(e) => setFood(e.target.value)}>
          <option value="">All Food</option>
          <option value="veg">Veg</option>
          <option value="nonveg">Non-Veg</option>
        </select>
      </div>

      {loading && <p className="muted">Loading...</p>}

      {filtered.length === 0 && !loading && (
        <p className="empty">No students found</p>
      )}

      {/* 🧾 LIST */}
      <div className="mess-grid">
        {filtered.map((s) => (
          <div key={s.id} className="mess-card">
            <div className="mess-header">
              <h4>{s.student_name}</h4>
              <span className={`badge ${s.is_paid ? "paid" : "pending"}`}>
                {s.is_paid ? "PAID" : "PENDING"}
              </span>
            </div>

            <p><b>Hostel:</b> {s.hostel_name}</p>
            <p><b>Room:</b> {s.room_number}</p>

            <p>
              <b>Food:</b>{" "}
              <span className={s.food_type === "veg" ? "veg" : "nonveg"}>
                {s.food_type.toUpperCase()}
              </span>
            </p>

            <p><b>Month:</b> {s.joined_month} {s.year}</p>

            <div className="price">₹ {s.price}</div>

            {/* 🔘 ACTIONS */}
            <div className="mess-actions">
              <button
                className={s.is_paid ? "btn-warning" : "btn-success"}
                onClick={() => togglePayment(s.id, s.is_paid)}
              >
                {s.is_paid ? "Mark Unpaid" : "Mark Paid"}
              </button>

              {/* <button
                className="btn-danger"
                onClick={() => removeFromMess(s.id)}
              >
                Remove
              </button> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}